import React, { useEffect, useState } from "react";
import { Grid, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { Dialog, DialogTitle, DialogContent, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import CustumTextField from "../../CustomComponant/CustomTextField ";
import apiClient from "../../BaseUrl/apiClient";
import {
  Button,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
} from "@mui/material";
import { Credit_Heading_Text_Color, Credit_Table_Heading_Background_Color, Debit_Heading_Text_Color, Debit_Table_Heading_Background_Color, Heading_Text_Color, Table_Heading_Text_Color } from "../../constant/constant";
import { decrypt } from "../../components/cryptoUtil";

const SearchComponent = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchOption, setSearchOption] = useState("TR Number"); // Default to 'TR Number'
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [crHeaders, setCrHeaders] = useState([]);
  const [crData, setCrData] = useState([]);
  const [drHeaders, setDrHeaders] = useState([]);
  const [drData, setDrData] = useState([]);
  const [error, setError] = useState("");
  const [pageLoader, setPageLoader] = useState(false);
  const [statioName, setStationName] = useState("");
  const [jour, setJour] = useState("");
  const [oldTR, setoldTR] = useState("");
  const [oldAmount, setoldAmount] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const [editMessage, setEditMessage] = useState("");

  const [username, setUsername] = useState('');

  const [userfullname, setUserFullname] = useState('');
  const [userrole, setUserrole] = useState(0);

const token = localStorage.getItem("token");


  useEffect(() => {
    const storedName = (JSON.parse(decrypt(localStorage.getItem('tokenData'))).userfullname) || '';
    const cuserrole = (JSON.parse(decrypt(localStorage.getItem('tokenData'))).userrole) || 0;
    const cuname = (JSON.parse(decrypt(localStorage.getItem('tokenData'))).userId) || '';


    setUserFullname(storedName);
    setUsername(cuname || '');
    setUserrole(Number(cuserrole) || 0);
  }, []);

  const handleSearchTermChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSearchOptionChange = (event) => {
    setSearchOption(event.target.value);
    setSearchTerm("");
    setMonth("");
    setYear("");
    setShowModal(false);
  };


  const filterRows = (rows) => {
    if (!searchQuery.trim()) return rows;
    return rows.filter(row =>
      Object.values(row).some(
        value => String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
    );
  };

  const filteredCrData = filterRows(crData);
  const filteredDrData = filterRows(drData);



  const handleMonthChange = (event) => {
    setMonth(event.target.value);
  };

  const handleYearChange = (event) => {
    setYear(event.target.value);
  };

  const handleSearchSubmit = async (event) => {
    setPageLoader(true);
    event.preventDefault();
    setError("");
    setCrData([]);
    setDrData([]);
    setShowModal(false);
    setSearchQuery("");
    try {

      
      let response;
      if (searchOption === "TR Number") {
        response = await apiClient.post("/search", {
          userid: username,
          searchTerm: searchTerm,
        },
         {headers: {
    'Content-Type': 'application/json',
     "Authorization": `Bearer ${token}`, // optional, set default headers
  },}
      
      
      
      );
      } else if (searchOption === "Amount") {
        response = await apiClient.post("/searchbydate", {
          userid: username,
          searchTerm: searchTerm,
          month: month,
          year: year,
        },
       {headers: {
    'Content-Type': 'application/json',
     "Authorization": `Bearer ${token}`, // optional, set default headers
  },});
      }

      if (response.data && Array.isArray(response.data.data)) {
        const data = response.data.data;
        const crTransformed = transformData(data[0] || []);
        const drTransformed = transformData(data[1] || []);

        setCrHeaders(getHeaders(data[0] || []));
        setCrData(crTransformed);
        setDrHeaders(getHeaders(data[1] || []));
        setDrData(drTransformed);
      } else {
        setError("Unexpected response structure or empty data.");
      }
    } catch (err) {
      console.error("Error fetching data:", err.message, err.response?.data);
      setError("There was an error fetching data.");
    }

    setPageLoader(false);
  };

  const transformData = (data) => {
    return data.map((item) => ({ ...item }));
  };

  const getHeaders = (data) => {
    if (!data.length) return [];
    const allKeys = data.reduce((keys, item) => {
      Object.keys(item).forEach((key) => keys.add(key));
      return keys;
    }, new Set());
    return Array.from(allKeys);
  };


  // Build a key for TR NUMBER + Amount
  const buildKey = (tr, amount) => `${tr}__${amount}`;

  const getDuplicates = (rows) => {
    const counts = {};
    rows.forEach(row => {
      const key = buildKey(row["TR NUMBER"], row["Amount"]);
      counts[key] = (counts[key] || 0) + 1;
    });
    return new Set(Object.keys(counts).filter(key => counts[key] > 1));
  };

  // For Credit
  const creditDuplicateKeys = getDuplicates(crData);

  // For Debit
  const debitDuplicateKeys = getDuplicates(drData);

  // Cross-match between Credit and Debit
  const creditKeys = new Set(crData.map(row => buildKey(row["TR NUMBER"], row["Amount"])));
  const debitKeys = new Set(drData.map(row => buildKey(row["TR NUMBER"], row["Amount"])));

  const crossMatchKeys = new Set(
    [...creditKeys].filter(key => debitKeys.has(key))
  );






  const Table = ({ headers, rows, isCredit }) => {
    const filteredHeaders = headers.filter(h => h !== "Matched Status");

    return (
      <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 20 }}>
        <thead>
          <tr>
            {filteredHeaders.map((header, i) => (
              <th key={i} style={{ border: "1px solid black", padding: 8, backgroundColor: isCredit ? Credit_Table_Heading_Background_Color : Debit_Table_Heading_Background_Color, color: Table_Heading_Text_Color, }}>{header}</th>
            ))}
            {isCredit && (
              <th style={{ border: "1px solid black", padding: 8, backgroundColor: isCredit ? Credit_Table_Heading_Background_Color : Debit_Table_Heading_Background_Color, Table_Heading_Text_Color, }}>Edit</th>
            )}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => {
            const isMatchedStatusOne = row["Matched Status"] === 1;
            const key = buildKey(row["TR NUMBER"], row["Amount"]);

            // Rule priority: Green > Red
            const isGreen = crossMatchKeys.has(key);
            const isRed = !isGreen && (
              isCredit
                ? creditDuplicateKeys.has(key)
                : debitDuplicateKeys.has(key)
            );

            return (
              <tr key={rowIndex}>
                {filteredHeaders.map((header, colIndex) => {
                  const baseStyle = {
                    border: "1px solid black",
                    padding: 8,
                    backgroundColor: isGreen
                      ? "lightgreen"
                      : isRed
                        ? "lightcoral"
                        : (["TR NUMBER", "Amount", "Bank Remark", "Station", "Entry Month", "Entry Year"].includes(header) && isMatchedStatusOne)
                          ? "green"
                          : "",
                  };
                  return (
                    <td key={colIndex} style={baseStyle}>
                      {row[header] || ""}
                    </td>
                  );
                })}
                {isCredit && (
                  <td style={{ border: "1px solid black", padding: 8 }}>
                    {!isMatchedStatusOne && (
                      <IconButton color="primary" onClick={() => handleEdit(row, filteredHeaders)}
                        disabled={!(userrole === 2 || userrole === 9 || userrole === 999)}
                      >
                        <EditIcon />
                      </IconButton>
                    )}
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  const handleUpdate = async () => {
    if (!input1 || !input2) {
      setError("Please fill in both TR NUMBER and Amount fields.");
      return;
    }

    try {
      const response = await apiClient.post("/update-credit", {
        userid: username,
        oldTR: oldTR,
        newTR: input1,
        oldAmount: oldAmount,
        newAmount: input2,
        journalNo: jour,
      },
     {headers: {
    'Content-Type': 'application/json',
     "Authorization": `Bearer ${token}`, // optional, set default headers
  },});

      if (response.data.success) {
        alert("✅ Updated successfully!");
        setShowModal(false);
        setInput1("");
        setInput2("");
        // Re-run search if needed:
        handleSearchSubmit(new Event("submit"));
      } else {
        setError(response.data.message || "❌ Update failed.");
      }
    } catch (err) {
      console.error("Update Error:", err);
      setError("❌ Failed to update. Try again.");
    }
  };




  const handleEdit = (row, headers) => {
    const message = headers.includes("Depot")
      ? `Update: Debit Data\n`
      : `Update: Credit Data\n`;

    setEditMessage(message);
    setStationName(row["Bank Remark"] || row.Station);
    setoldTR(row["TR NUMBER"]);
    setoldAmount(row.Amount);
    setInput2(row.Amount);
    setJour(row["JOURNAL-NO"]);

    setTimeout(() => {
      setShowModal(true);
    }, 0);
  };

  useEffect(() => {
    // Reset data when search option changes
    setCrData([]);
    setDrData([]);
    setError('');
    setShowModal(false);
    setInput1("");
    //setInput2("");
  }, [searchOption, month, year, searchTerm, oldAmount, oldTR, jour]);


  const handleClose = () => {
    setShowModal(false);
    setInput1("");
    setInput2("");
  };

  return (
    <div>
      {pageLoader && (
        <div className="loaderContainer">
          <CircularProgress />
        </div>
      )}

      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <h2 gutterBottom style={{ margin: 0, color: Heading_Text_Color, textAlign: 'center' }} >🔎 Search Your TR</h2>

      </div>








      <form onSubmit={handleSearchSubmit}>

        <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>

          <FormControl fullWidth>
            <InputLabel id="search-option-label">Search By</InputLabel>
            <Select
              labelId="search-option-label"
              value={searchOption}
              size="small"
              onChange={handleSearchOptionChange}
            >
              <MenuItem value="TR Number">TR Number</MenuItem>
              <MenuItem value="Amount">Amount</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <CustumTextField
              size="small"
              value={searchTerm}
              onChange={handleSearchTermChange}
              //placeholder={`Enter TR Number Minimum ${searchOption === 'TR Number' ? '5' : '1'} Character`}
              placeholder={`${searchOption === "TR Number" ? "Enter TR Number Minimum 5 Character" : "Enter Amount Minimum 1 Character"} `}
              style={{ marginBottom: "16px", minWidth: "160px" }}

            />
          </FormControl>
        </div>
        {searchOption === "Amount" && (
          <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
            <FormControl fullWidth>
              <InputLabel id="month-label">Month</InputLabel>
              <Select
                size="small"
                labelId="month-label"
                value={month}
                onChange={handleMonthChange}
              >
                {Array.from({ length: 12 }, (_, i) => (
                  <MenuItem key={i + 1} value={i + 1}>
                    {new Date(0, i).toLocaleString("default", {
                      month: "long",
                    })}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel id="year-label">Year</InputLabel>
              <Select
                size="small"
                labelId="year-label"
                value={year}
                onChange={handleYearChange}
              >
                {Array.from({ length: 10 }, (_, i) => {
                  const currentYear = new Date().getFullYear();
                  const yearValue = currentYear - i;
                  return (
                    <MenuItem key={i} value={yearValue}>
                      {yearValue}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </div>
        )}




        <Button
          type="submit"
          variant="contained"
          color="primary"
          sx={{
            mt: 2, // adds theme spacing (2 × 8px = 16px)
            fontWeight: 'bold',
            borderRadius: '8px',
            paddingX: 3,
            paddingY: 1,
            fontSize: '16px',
            textTransform: 'none'
          }}
          disabled={
            searchOption === "TR Number"
              ? searchTerm.length <= 4
              : searchTerm.length < 1
          }
        >
          Search
        </Button>

      </form>



      <Dialog open={showModal} onClose={() => setShowModal(false)}>

        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>




        <DialogTitle>{editMessage}</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="normal"
            size="small"
            label="Bank Description (Station Name)"
            value={statioName}
            // onChange={(e) => setInput1(e.target.value)}
            variant="outlined"
            disabled={true}
            sx={{
              // Change the input text color
              '& .MuiInputBase-input.Mui-disabled': {
                color: 'red',
                WebkitTextFillColor: 'red', // Needed for WebKit browsers (Chrome, Safari)
              },

            }}
          />

          <TextField
            fullWidth
            margin="normal"
            label="Journal Number"
            size="small"
            value={jour}
            // onChange={(e) => setInput1(e.target.value)}
            variant="outlined"
            disabled={true}
          />

          <TextField
            fullWidth
            size="small"
            margin="normal"
            label="Old TR NUMBER"
            value={oldTR}
            // onChange={(e) => setInput1(e.target.value)}
            variant="outlined"

            disabled={true}


            sx={{
              // Change the input text color
              '& .MuiInputBase-input.Mui-disabled': {
                color: 'red',
                WebkitTextFillColor: 'red', // Needed for WebKit browsers (Chrome, Safari)
              },
              // Change the label color
              '& .MuiInputLabel-root.Mui-disabled': {
                color: 'red',
              },
              // Change the border color (optional)
              '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                borderColor: 'red',
              },
            }}
          />

          <TextField
            fullWidth
            size="small"
            margin="normal"
            label="New TR NUMBER"
            value={input1}
            onChange={(e) => setInput1(e.target.value)}
            variant="outlined"
            sx={{
              // Change the input text color
              '& .MuiInputBase-input': {
                color: 'green', // Change to your desired color
              },
              // Change the label color
              '& .MuiInputLabel-root': {
                color: 'green', // Change to your desired color
              },
              // Change the border color (optional)
            }}

          />


          <TextField
            fullWidth
            margin="normal"
            label="Amount"
            size="small"
            disabled={true}
            value={input2}
            onChange={(e) => setInput2(e.target.value)}
            variant="outlined"
            sx={{
              // Change the input text color
              '& .MuiInputBase-input.Mui-disabled': {
                color: 'red',
                WebkitTextFillColor: 'red', // Needed for WebKit browsers (Chrome, Safari)
              },
              // // Change the label color
              '& .MuiInputLabel-root.Mui-disabled': {
                color: 'red',
              },
            }}
          />


          <Button
            fullWidth
            variant="contained"
            color="success"
            sx={{ mt: 2 }}
            //onClick={() => setShowModal(false)}
            onClick={handleUpdate}
            //disabled={!input1.trim() || !input2.trim()}
            disabled={!input1.trim()}
          >
            Update & Close
          </Button>
        </DialogContent>
      </Dialog>







      {error && <p style={{ color: "red" }}>{error}</p>}

      {(crData.length > 0 || drData.length > 0) && (
        <>
          <div>
            <Grid xs={6} sm={3} md={3} sx={{ mt: 2 }}>
              <TextField
                size="small"
                fullWidth
                label="🔍 Search from Result"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </Grid>




            <h3 style={{ color: Credit_Heading_Text_Color }}>🏦 Credit Data</h3>
            {/* <Table headers={crHeaders} rows={crData} isCredit={true} /> */}
            <Table headers={crHeaders} rows={filteredCrData} isCredit={true} />
            <h3 style={{ color: Debit_Heading_Text_Color }}> 🚂 Debit Data</h3>
            {/* <Table headers={drHeaders} rows={drData} isCredit={false} /> */}
            <Table headers={drHeaders} rows={filteredDrData} isCredit={false} />
          </div>
        </>
      )}



      {/* <WhatsAppButton/> */}

    </div>
  );
};

export default SearchComponent;
